import { render, staticRenderFns } from "./TrafficCard.vue?vue&type=template&id=d2f912f4"
import script from "./TrafficCard.vue?vue&type=script&lang=js"
export * from "./TrafficCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports